import { FC } from 'react';

import { WorkspaceSelector } from 'components/Layout/Sidebar/WorkspaceSelector';
import { useWorkspacesForWorkspaceSelector } from 'components/Layout/Sidebar/WorkspaceSelector/useWorkspacesForWorkspaceSelector';
import TeamSelector from 'components/TeamSelector/TeamSelector';
import { useTeamsForTeamSelector } from 'components/TeamSelector/useTeamsForTeamSelector';
import { useWorkspacesFeatureEnabled } from 'global/growthbookUtils';

/**
 * We can only render one of the workspace or team selector at a time.
 * This component will determine which one to render based on the user's FF's
 * and the data available
 */
export const WorkspaceOrTeamSelector: FC = () => {
  const isEnabled = useWorkspacesFeatureEnabled();

  const workspaces = useWorkspacesForWorkspaceSelector();
  const teams = useTeamsForTeamSelector();

  if (isEnabled) {
    if (workspaces) {
      return <WorkspaceSelector />;
    }
    // still loading - everyone is in a workspace so we don't need to show the team selector
    return null;
  }

  if (teams) {
    return <TeamSelector />;
  }
  // no loading state for now
  return null;
};
